import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@environments/environment';

/**
 * HTTP Interceptor that adds cache control headers when caching is disabled globally.
 * This prevents HTTP responses from being cached by the browser.
 */
@Injectable()
export class CacheControlInterceptor implements HttpInterceptor {

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // If caching is disabled, add headers to prevent caching
        if (environment.cacheDisabled) {
            const noCacheReq = req.clone({
                setHeaders: {
                    'Cache-Control': 'no-cache, no-store, must-revalidate',
                    'Pragma': 'no-cache',
                    'Expires': '0'
                }
            });
            return next.handle(noCacheReq);
        }

        // Otherwise, pass the request through unchanged
        return next.handle(req);
    }
}